import { CoreTag } from '@featuring-corp/components';
import { flex } from '@styles/vanilla-extract/utils';
import React, { Fragment } from 'react';

import { BiMap } from '@utils/objects';

import { ReportProfileProps } from './ReportProfile';
import {
	bioClass,
	containerClass,
	platformIconClass,
	profileImgClass,
	rawDividerClass,
	textContainerClass,
	textInnerContainer,
	userNameClass,
} from './style.css';
import LargeAvatar from '../large-avatar/LargeAvatar';
import SnsRounded from '../sns-rounded/SnsRounded';
import CoreSkeletonBox from 'src/shared/CoreSkeletonBox';

const ReportProfileLoading = ({ profileImg, username, rawData }: ReportProfileProps) => {
	const rawDataBiMap = new BiMap(rawData);
	return (
		<div className={containerClass}>
			<div className={profileImgClass}>
				<LargeAvatar
					src={profileImg}
					alt={'influencer profile image'}
					name={username}
					isBorder
					isLoading={true}
				/>
				<SnsRounded className={platformIconClass} />
			</div>

			<div className={textContainerClass}>
				<div className={textInnerContainer}>
					<CoreTag tagType="gray" text={'분석 중'} />

					<h3 className={userNameClass}>{'데이터를 불러오는 중'}</h3>

					<p className={bioClass}>Loading...</p>
				</div>

				<div className={flex({ gap: 'spacing-400' })}>
					{rawDataBiMap.keys().map((key, idx) => (
						<Fragment key={idx}>
							{idx !== 0 && <div className={rawDividerClass} />}
							<div className={flex({ gap: 'spacing-100' })}>
								<CoreSkeletonBox _width="40px" _height="14px" radius="4px" />
							</div>
						</Fragment>
					))}
				</div>
			</div>
		</div>
	);
};

export default ReportProfileLoading;
